import React from 'react';
import { Route } from '@/navigation/Route';
import { HomeEventCloseScreen } from '@/features/eventClose/screens/Home';
import { IncomeScreen } from './screens/Income';
import { ExpenseManualEntriesScreen } from './screens/Expense';
import { HomeMachineEventCloseScreen } from './screens/HomeMachine';
import { FinalSettlementScreen } from './screens/FinalSettlement';
import { MachinesTicketSalesScreen } from './screens/MachinesTicketSales';
import { MachinesProductSalesScreen } from './screens/MachinesProductSales';
import { MachinesReportScreen } from './screens/MachinesReport';
import { EventCloseScreen } from './screens/Events';

export const EVENTCLOSE_ROUTES = {
  itself: '/financial/event-close',
  home: '/financial/event-close/:id',
  generalCollection: '/financial/event-close/general-collection/:id',
  income: '/financial/event-close/income/:id',
  expense: '/financial/event-close/expense/:id',
  machines: '/financial/event-close/machines/:id',
  machinesTicketSales: '/financial/event-close/machines/ticket-sales/:id',
  machinesProductSale: '/financial/event-close/machines/product-sale/:id',
  machinesReport: '/financial/event-close/machines/report/:id',
  finalSettlement: '/financial/event-close/final-settlement/:id',
};

export const EventCloseNavigation = (): JSX.Element => (
  <>
    <Route exact path={EVENTCLOSE_ROUTES.itself} component={EventCloseScreen} isPrivateRoute />
    <Route exact path={EVENTCLOSE_ROUTES.home} component={HomeEventCloseScreen} isPrivateRoute />
    <Route exact path={EVENTCLOSE_ROUTES.income} component={IncomeScreen} isPrivateRoute />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.expense}
      component={ExpenseManualEntriesScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.machines}
      component={HomeMachineEventCloseScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.machinesTicketSales}
      component={MachinesTicketSalesScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.machinesProductSale}
      component={MachinesProductSalesScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.machinesReport}
      component={MachinesReportScreen}
      isPrivateRoute
    />
    <Route
      exact
      path={EVENTCLOSE_ROUTES.finalSettlement}
      component={FinalSettlementScreen}
      isPrivateRoute
    />
  </>
);
